<template>
  <div class="PageGuard">
    <PageHeaderMobile :pageHeaderTitle="pageHeaderTitle" @goBack="goBack"></PageHeaderMobile>
    <div class="section-top">
      <CardOrder v-if="reserveData && reserveData.id" :key="reserveData.id">
        <div slot="cardHeader" class="card-header">
          <h5 class="h5">{{ $t("pages.wording.reserveTitle") }}</h5>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.reserveNo") }}</div>
            <div class="value">{{ reserveData.reserveNo }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.carPlat") }}</div>
            <div class="value">{{ reserveData.tempCar ? reserveData.tmpCarPlat : reserveData.carPlat }}</div>
          </div>
        </div>
        <div slot="cardFooter" class="card-footer">
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.grossWeight") }}</div>
            <div class="value">{{ totalGrossWeight }} {{ weightUnit }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.packWeight") }}</div>
            <div class="value">{{ totalPackWeight }} {{ weightUnit }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.netWeight") }}</div>
            <div class="value">{{ totalNetWeight }} {{ weightUnit }}</div>
          </div>
        </div>
      </CardOrder>
    </div>
    <Tabs :tabsData="tabsData" :active="activeTab" @tabClick="getActiveTab">
      <div slot="tab1" class="listGroup">
        <ListView v-for="(item, index) in reserveSOList" :key="index" @listClick="goReleaseDetailPage(item)">
          <div class="list-content">
            <div class="list-item">
              <div class="label">{{ $t("pages.wording.releaseNumber") }}</div>
              <div class="value">{{ item.releaseOrderNo }}</div>
            </div>
            <div class="list-item">
              <div class="label">Plant Code</div>
              <div class="value">{{ item.plantCode }}</div>
            </div>
            <div class="list-item">
              <div class="label">{{ $t("pages.wording.netWeight") }}</div>
              <div class="value">{{ singleOrdertotalNetWeight(item.releaseOrderNo) }}</div>
            </div>
          </div>
        </ListView>
      </div>
      <div slot="tab2">
        <CardTable v-if="reserveData && reserveData.id" :key="reserveData.id">
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.applicatorID") }}</div>
            <div class="value">{{ reserveData.applicatorID }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.applicatorName") }}</div>
            <div class="value">{{ reserveData.deltaContactName }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.applicatorNumber") }}</div>
            <div class="value">{{ reserveData.deltaContactNumber }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.applicatorDepCode") }}</div>
            <div class="value">{{ reserveData.applicatorDeptCode }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.applicatorDepName") }}</div>
            <div class="value">{{ reserveData.deltaContactDept }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.applicatorArea") }}</div>
            <div class="value">{{ reserveData.reserveArea }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.vendorInfo") }}</div>
            <div class="value">{{ reserveData.OACode }} / {{ reserveData.vendor }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.reserveFactory") }}</div>
            <div class="value">{{ reserveData.reserveFactory }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.reserveLocation") }}</div>
            <div class="value">{{ $store.getters.getSysCodeText("location", reserveData.reserveLocation) }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.salesDate") }}</div>
            <div class="value">{{ formateDatetimeStr("DateTime", reserveData.reserveArriveDate) }}</div>
          </div>
        </CardTable>
      </div>
    </Tabs>
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import _ from "lodash"
import PageHeaderMobile from "@/components/common/PageHeaderMobile.vue"
import CardOrder from "@/components/common/CardOrder.vue"
import CardTable from "@/components/common/CardTable.vue"
import ListView from "@/components/common/ListView.vue"
import Tabs from "@/components/common/Tabs.vue"
import { utils } from "@/utils/utils.js"

export default {
  name: "PageGuardReservationReleaseList",
  components: {
    PageHeaderMobile,
    CardOrder,
    CardTable,
    ListView,
    Tabs,
  },
  props: {
    reserveID: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      pageHeaderTitle: this.$t("pages.wording.releaseList"),
      activeTab: "tab1",
      tabsData: [
        {
          name: "tab1",
          label: this.$t("pages.wording.releaseDetail"),
        },
        {
          name: "tab2",
          label: this.$t("pages.wording.otherInfo"),
        },
      ],
      reserveSOList: [],
      reserveData: {},
      leaveDateTime: "",
      reserveDataID: -1,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let guardTempReleaseParams = window.sessionStorage.getItem("guardTempReleaseParams")
      if (guardTempReleaseParams !== null) {
        let releaseParams = JSON.parse(guardTempReleaseParams)
        this.reserveDataID = parseInt(releaseParams.reserveDataID)
      } else {
        this.reserveDataID = this.reserveID
      }
      this.getReserveInfo()
      this.getSOTableList()
    },
    goBack() {
      let guardTempReleaseParams = window.sessionStorage.getItem("guardTempReleaseParams")
      window.sessionStorage.removeItem("guardTempReleaseParams")
      if (guardTempReleaseParams !== null) {
        let releaseParams = JSON.parse(guardTempReleaseParams)
        this.$router.push({
          name: releaseParams.station,
        })
      } else {
        this.$router.go(-1)
      }
    },
    getActiveTab(val) {
      this.activeTab = val
    },
    getReserveInfo() {
      let vueInstance = this
      let params = { params: { id: this.reserveDataID } }
      api
        .apiGetReserveInfo(params)
        .then((response) => {
          if (response.data) {
            let data = response.data.result
            vueInstance.reserveData = data.reserveData
            vueInstance.leaveDateTime =
              data.reserveData.leaveDateTime === null
                ? ""
                : utils.getFormateDateTime("DateTime", data.reserveData.leaveDatetime)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getSOTableList() {
      api
        .apiGetSOTableBindingWithReserve(this.reserveDataID)
        .then((res) => {
          if (res) {
            let result = _.chain(res.data)
              .initial()
              .groupBy("releaseID")
              .map((items, releaseID) => ({
                releaseID: parseInt(releaseID),
                releaseOrderNo: items[0].releaseOrderNo,
                SO: items[0].SO,
                plantCode: items[0].plantCode,
                data: items.map(({ releaseID, ...rest }) => rest),
              }))
              .value()
            this.reserveSOList = result
          } else {
            this.reserveSOList = []
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    goReleaseDetailPage(data) {
      this.$router.push({
        name: "PageGuardReservationReleaseInfo",
        params: { reserveData: data, leaveDateTime: this.leaveDateTime },
      })
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
  computed: {
    singleOrdertotalNetWeight() {
      return (releaseOrderNo) => {
        let totalNetWeight = 0
        this.reserveSOList.forEach((item) => {
          if (item.releaseOrderNo === releaseOrderNo) {
            item.data.forEach((data) => {
              totalNetWeight += data.netWeight
            })
          }
        })
        return totalNetWeight
      }
    },
    totalGrossWeight() {
      return parseFloat(
        (this.reserveSOList == null
          ? 0
          : this.reserveSOList.reduce((acc, item) => {
              return (
                acc +
                item.data.reduce((acc2, so) => {
                  return acc2 + parseFloat(so.grossWeight.toFixed(this.$global.defaultPointNumForRelease))
                }, 0)
              )
            }, 0)
        ).toFixed(this.$global.defaultPointNumForRelease)
      )
    },
    totalPackWeight() {
      return parseFloat(
        (this.reserveSOList == null
          ? 0
          : this.reserveSOList.reduce((acc, item) => {
              return (
                acc +
                item.data.reduce((acc2, so) => {
                  return acc2 + parseFloat(so.packWeight.toFixed(this.$global.defaultPointNumForRelease))
                }, 0)
              )
            }, 0)
        ).toFixed(this.$global.defaultPointNumForRelease)
      )
    },
    totalNetWeight() {
      return parseFloat(
        (this.reserveSOList == null
          ? 0
          : this.reserveSOList.reduce((acc, item) => {
              return (
                acc +
                item.data.reduce((acc2, so) => {
                  return acc2 + parseFloat(so.netWeight.toFixed(this.$global.defaultPointNumForRelease))
                }, 0)
              )
            }, 0)
        ).toFixed(this.$global.defaultPointNumForRelease)
      )
    },
    weightUnit() {
      return this.reserveSOList !== null && this.reserveSOList.length > 0 ? this.reserveSOList[0].data[0].unit : ""
    },
  },
}
</script>
<style scoped>
.PageGuard {
  margin: 0 -20px -20px -20px;
  padding-top: 20px;
}

.section-top {
  background: var(--white);
  padding: 16px 16px 16px 16px;
}

.section-top .h5 {
  font-size: var(--subTitle-font-size);
  line-height: var(--subTitle-line-height);
  font-weight: bold;
}

.section-top .cardOrder {
  cursor: default;
}

.section-top .card-header {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 12px;
  column-gap: 16px;
}

.Tabs ::v-deep .el-tabs__content #pane-tab1 .listGroup {
  display: grid;
  row-gap: 4px;
}
</style>
